export default "__VITE_ASSET__ChgN$bY___"